import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import { useMarketAnalysisInsightToStrategyContent } from '../../../../hooks/useMarketAnalysisInsightToStrategyContent';
import './InsightToStrategy.css';

const InsightToStrategy = () => {
  const { content, isLoading } = useMarketAnalysisInsightToStrategyContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, cta } = content;

  return (
    <section className="insight-to-strategy">
      <div className="insight-to-strategy__inner">
        <Reveal className="insight-to-strategy__content">
          <h2 className="insight-to-strategy__title">{title}</h2>
          {text ? <p className="insight-to-strategy__text">{text}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="insight-to-strategy__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>
      </div>
    </section>
  );
};

export default InsightToStrategy;
